<template>
  <div class="management-contract">
    <el-card>
      <el-form ref="form" label-width="80px" inline style="margin-top: 30px">
        <el-form-item>
          <el-input
            v-model="memberInfo"
            placeholder="请输入姓名手机号或身份证号"
            style="width: 250px"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="value"
            multiple
            placeholder="请选择标签(或)"
            style="width: 200px"
          >
            <el-option
              v-for="item in PatientLabel"
              :key="item.id"
              :label="item.tabName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-select
            v-model="value1"
            multiple
            placeholder="请选择标签(与)"
            style="width: 200px"
          >
            <el-option
              v-for="item in PatientLabel"
              :key="item.id"
              :label="item.tabName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="query">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="choice">选择问卷</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-table
      :data="list"
      v-loading="loading"
      border
      ref="multipleTable"
      tooltip-effect="dark"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column prop="name" label="姓名"></el-table-column>
      <el-table-column
        prop="tabNames"
        label="健康标签"
        width="200"
      ></el-table-column>
      <el-table-column prop="age" label="年龄"></el-table-column>
      <el-table-column
        prop="idNumber"
        label="身份证号"
        width="200"
      ></el-table-column>
      <el-table-column prop="phone" label="手机号"></el-table-column>
      <el-table-column
        prop="isBind"
        label="是否绑定"
        :formatter="formatterisBind"
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        :formatter="formattercreateTime"
        width="200"
      ></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            @click.prevent="showCheckDialog(scope.row.id)"
            type="primary"
            size="small"
            >管理方案
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="选择问卷" :visible.sync="dialogTableVisible">
      <el-table
        :data="QuestionnaireList"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="QuestionnaireListChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column property="title" label="问卷名称"></el-table-column>
      </el-table>
      <el-row style="text-align: center; margin-top: 20px">
        <el-button type="primary" @click="end">发送</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import { Message } from "element-ui";
import axiosUtil from "../../utils/AxiosUtils.js";
export default {
  data() {
    return {
      gridData: [],
      dialogTableVisible: false,
      memberInfo: "",
      list: [],
      loading: false,
      value: "",
      value1: "",
      PatientLabel: [],
      multipleSelection: [],
      page: {
        pageNum: 1,
        pageSize: 1000,
        total: 0,
      },
      QuestionnaireList: [],
      QuestionnaireListId: [],
    };
  },
  mounted() {
    this.init();
    this.initPatientLabel();
  },
  methods: {
    end() {
      if (JSON.stringify(this.QuestionnaireListId) == "[]") {
        Message({
          message: "请先选择健康问卷",
          type: "error",
        });
        return;
      }
      let _this = this;
      let array=[];
      for(let i in _this.QuestionnaireListId){
        array.push(_this.QuestionnaireListId[i].id)
      }
      axiosUtil(
        {
          service: "smarthos.sanbo.health.push.questionnaire.template.member",
          docId: JSON.parse(sessionStorage.getItem("loginInfo")).doc.id,
          questionnaireList: array,
          memberList: _this.multipleSelection,
          pageUrl: "/pagesMember/datiDetails/datiDetails",
          source: "SANBOYUN",
        },
        ({ code, list, msg }) => {
          if (code == "0") {
            Message({
              message: "推送成功",
              type: "success",
            });
            _this.dialogTableVisible = false;
            _this.QuestionnaireListId = [];
            _this.multipleSelection = [];
          } else {
            Message({
              message: msg,
              type: "error",
            });
          }
        }
      );
    },
    query() {
      this.init();
    },
    initPatientLabel() {
      let _this = this;
      axiosUtil(
        {
          service: "smarthos.sanbo.health.member.all.tab.list",
        },
        ({ code, list, msg }) => {
          if (code == "0") {
            _this.PatientLabel = list;
          } else {
            Message({
              message: msg,
              type: "error",
            });
          }
        }
      );
    },
    QuestionnaireListChange(val) {
      this.QuestionnaireListId=val;
      // const set = new Set(this.QuestionnaireListId);
      // this.QuestionnaireListId = [...set];
      // console.log(this.QuestionnaireListId)
    },
    handleSelectionChange(val) {
      for (let i in val) {
        this.multipleSelection.push(val[i].id);
      }
    },
    choice() {
      if (JSON.stringify(this.multipleSelection) == "[]") {
        Message({
          message: "请先选择健康会员",
          type: "error",
        });
        return;
      }
      let _this = this;
      axiosUtil(
        {
          service: "smarthos.sanbo.questionnaire.list.all",
          source: "SANBOYUN",
        },
        ({ code, list, msg }) => {
          if (code == "0") {
            _this.QuestionnaireList = list;
            _this.dialogTableVisible = true;
          } else {
            Message({
              message: msg,
              type: "error",
            });
          }
        }
      );
    },
    onCurrentChange(pageNum) {
      this.page.pageNum = pageNum;
      this.getMedicineList();
    },
    showCheckDialog(id) {
      this.$router.push({ path: "programmeList", query: { id: id } });
    },
    formatterisBind(row, column, code) {
      if (row.isBind == "1") {
        return "已绑定";
      } else if (row.isBind == "0") {
        return "未绑定";
      }
    },
    formattercreateTime(row) {
      return this.getDate(row.createTime);
    },
    getDate(tm) {
      var tt = new Date(parseInt(tm))
        .toLocaleString()
        .replace(/年|月/g, "-")
        .replace(/日/g, "        ");
      return tt;
    },
    init() {
      let _this = this;
      axiosUtil(
        {
          service: "smarthos.sanbo.health.doc.sign.member.list.V1",
          source: "SANBOYUN",
          pageNum: _this.page.pageNum,
          pageSize: _this.page.pageSize,
          memberInfo: _this.memberInfo,
          tabList: _this.value,
          tabAndList: _this.value1,
          docId: JSON.parse(sessionStorage.getItem("loginInfo")).doc.id,
        },
        ({ code, obj, msg }) => {
          if (code == "0") {
            _this.list = obj.userHealthMemberVoList;
            _this.page.total = obj.amout;
          } else {
            Message({
              message: msg,
              type: "error",
            });
          }
        }
      );
    },
  },
};
</script>

<style lang="scss">
.management-contract {
  .el-form {
    padding-top: 22px;
    border-top: 1px solid #f5f5f5;
  }
  .el-table {
    margin-top: 15px;
  }
  .pagination-wrapper {
    padding: 20px 0;
  }
  .el-table .cell {
    max-height: 69px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }
}
</style>
